import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/Phone.png'


const _withScopeId = n => (_pushScopeId("data-v-7eb0244a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row align-items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-6 col-sm-12 text-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "img-fluid mb-5",
    "data-aos": "fade-up"
  })
], -1))
const _hoisted_4 = { class: "col-lg-6 col-sm-12 text-black" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  class: "text-white",
  "data-aos": "fade-up"
}, "QUESTIONS? CONTACT US!", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text-white",
  "data-aos": "fade-up"
}, [
  /*#__PURE__*/_createTextVNode("You can use this form if you have a question or remark. We will answer it within 24 hours. You can also reach us by sending an email to "),
  /*#__PURE__*/_createElementVNode("a", { href: "mailto:info@projectlifekey.com" }, "info@projectlifekey.com")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Contact = _resolveComponent("Contact", true)!

  return (_openBlock(), _createElementBlock("div", {
    class: "bg",
    style: _normalizeStyle({'background-image' : 'url('+ require('@/assets/contact.jpg') +')'}),
    id: "contact"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _createVNode(_component_Contact, { "data-aos": "fade-up" })
        ])
      ])
    ])
  ], 4))
}